// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { brandCardStyles } from "@synd/App/Components/Brand/BrandCard";
import { fontConfig } from "@synd/XDL/PreStyle/typography";
import { css } from "styled-components";

brandCardStyles.brandWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 12px;
        align-items: center;
        max-width: 100%;
    `,
};

brandCardStyles.imageWrapper = {
    css: css`
        aspect-ratio: 1;
        width: 100%;
    `,
};

brandCardStyles.image = {
    css: css`
        max-width: 100%;
        max-height: 100%;
        aspect-ratio: 1;
        border-radius: 100%;
        overflow: hidden;
    `,
};

brandCardStyles.title = {
    color: "text",
    typographyProps: {
        variant: "h5",
        weight: fontConfig.weight.bold,
        css: css`
            margin-bottom: 0;
            text-align: center;
        `,
    },
};
